module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FtYWRhXzEiIGRhdGEtbmFtZT0iQ2FtYWRhIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDIwLjk4IDE2Ljk0Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2EzYTNhMzt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmljb25lczwvdGl0bGU+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMCwwVjE2Ljk0SDIxVjBaTTE4LjE2LDEuNTRsLTcuOTMsNi03LjUxLTZaTTEuMjMsMTUuNFYyLjE4bDksNy4yLDkuNTMtNy4yNFYxNS40WiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./static/messages.svg
// module id = ybm0
// module chunks = 1